"use client";
import { ArrowDown } from "lucide-react";

const StartWithSetButton = () => {
  return (
    <div
      onClick={() => {
        document
          .getElementById("landing-slider")
          ?.scrollIntoView({ behavior: "smooth" });
      }}
      className="bg-[#FFCF00] text-[#404040] flex flex-row gap-x-1 py-3 px-6 rounded-[10px] mt-6 cursor-pointer hover:brightness-90 active:brightness-90 items-center w-full md:w-fit place-content-center text-center"
    >
      مشاهده محتواها
      <ArrowDown />
    </div>
  );
};
export default StartWithSetButton;
